var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoHeaderCollinsonBlue = function SvgLogoHeaderCollinsonBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    d: "M34.233 24.57c-3.017 5.295-9.052 8.93-16.04 8.93-1.826 0-3.652-.316-5.24-.71a16.029 16.029 0 0 0 12.387-8.22zM10.944 6.064c1.904 0 3.728.473 5.314 1.418-4.203 1.024-7.375 4.885-7.375 9.454 0 4.568 3.172 8.349 7.375 9.452-1.586.866-3.41 1.418-5.314 1.418C4.917 27.806 0 22.922 0 16.936 0 10.949 4.917 6.064 10.944 6.064M17.136.5c6.987 0 13.022 3.614 16.04 8.8h-8.893c-2.461-4.479-7.067-7.622-12.388-8.093C13.484.736 15.31.5 17.136.5"
  })));
};
export default SvgLogoHeaderCollinsonBlue;